import { Header } from "../components/header/Header";
import FooterOne from "../components/footer/FooterOne";
import LegalText from "../components/content/LegalText";

const Legal = () => {
  return (
    <div>
      <div style={{ backgroundColor: "#05080b" }}>
        {/* <FeaturesTwoWithImage /> */}
        <Header />
      </div>
      <LegalText />
      <FooterOne />
    </div>
  );
};

export default Legal;
